import { render, staticRenderFns } from "./AppDonut.vue?vue&type=template&id=e5b70c6c"
import script from "./AppDonut.vue?vue&type=script&lang=js"
export * from "./AppDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports